// TODO clean up: 'suggestion' kind is never used
import React, {useState, useContext, useEffect, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Config from "../../config"
import Util from "../../util"
import Data from "../../data"

// components
import {FavouriteToggle2 as FavouriteToggle, Link, Rating} from "./index"
import {AsyncImage} from "../controls"

// context
import {ScrollContext} from "../../context/ScrollContext"

// styling and icons
import "./ActivityLink.scss";
import {faCartPlus} from "@fortawesome/free-solid-svg-icons";

/**
 * 
 * @param {*} param0 
 */
function ActivityLink({activity, kind}) {
  // TODO is called a LOT of times ... e.g. when sitting at the top of the search list more than 130 timesX
  
  // state
  const [displayAsPlaceholder, setDisplayAsPlaceholder] = useState(true)

  // ref
  const refTop = useRef()
  
  // context
  let scroll = useContext(ScrollContext)

  // scroll timestamp changed > check if above fold
  useEffect(() => {
    if(displayAsPlaceholder) {
      if(refTop.current) {
        const position = refTop.current.getBoundingClientRect()
        if(position.top < window.innerHeight) {
          setDisplayAsPlaceholder(false)
        }
      } 
    }
  }, [scroll.timestamp])
  

  // component did update (i.e. on each render)
  useEffect(() => {
    if(displayAsPlaceholder) {
      if(refTop.current) {
        const position = refTop.current.getBoundingClientRect()
        if(position.top < window.innerHeight) {
          setDisplayAsPlaceholder(false)
        }
      } 
    }
  })
  
  // the image
  let image = Data.Activity.getDefaultImage(activity)
  
  // New / Bestseller flag
  let flag = null
  if(activity.isHomeDelivery) {
    flag = <span className="flag">zuhause</span>
  }
  else if(activity.isOnlineEvent) {
    flag = <span className="flag">online</span>
  }
  else if(activity.isFresh) {
    flag = <span className="flag">Neu</span>
  }
  else if(activity.isBestseller) {
    flag = <span className="flag">Bestseller</span>
  }

  // the image - 
  // NOTE: Config.displayActivityImages is set depending on environment, 
  // in development it is set to false, to reduce bandwidth, you can
  // quickly change this behaviourby changing devOverride to true
  const devOverride = true;
  let img = null
  if(!displayAsPlaceholder && (Config.displayActivityImages || devOverride)) {
    img = <AsyncImage src={image.url_thumbnail || image.url} alt={activity.title} />
  }

  // render
  /*
  +--------+-------+
  | Image  | Titl  | <top>
  |        | Rati  |  <left><image></left> | <right></right>
  |        | Shor  | <top>
  |        | Avai  |
  +---+----+-------+
  | Preis      ❤ + | <bottom>.price .fav .cart</bottom>
  +---+------------±
  */
  return (
    <div className="c-activity-link" ref={refTop}>
      <div className="inner boxshadow">
        <div className="top">
          <div className="left">
            {flag}
            <div className={`image ${displayAsPlaceholder ? "placeholder" : ""}`}>
              <Link to={`/activity/${activity.slug}`}>
                {img}
              </Link>
            </div>
          </div>
          <div className="right">
            <LinkedTitle activity={activity} />
            <LinkedRating activity={activity} />
            <LinkedDescription activity={activity} />
            <LinkedRegions activity={activity} />
          </div>
        </div>
        <div className="bottom">
          <LinkedPrice activity={activity} />
          <FavouriteToggle activityId={activity._id} className="favourite" />
          <LinkedCart activity={activity} />
        </div>
      </div>
    </div>
  )

}

function LinkedPrice({activity}) {
  const [price, setPrice] = useState(0);
  useEffect(() => {
    // the lowest price
    let minPrice = activity.__minPricePerPerson;
    setPrice(Util.Format.currency(minPrice.toFixed(2), true));
  }, [])
  return (
    <Link to={`/activity/${activity.slug}`}>
      <div className="price">
        pro Person ab <span className="amount">{price}</span>
      </div>
    </Link>
  )
}

function LinkedCart({activity}) {
  return (
    <Link to={`/activity/${activity.slug}`}>
      <div className="cart"><FontAwesomeIcon icon={faCartPlus} /></div>
    </Link>
  )
}

function LinkedTitle({activity}) {
  return (
    <Link to={`/activity/${activity.slug}`}>
      <div className="title">
        {activity.title}
      </div>
    </Link>
  )
}

function LinkedDescription({activity}) {
  return (
    <Link to={`/activity/${activity.slug}`}>
      <div className="description">
        {activity.shortDescription}
      </div>
    </Link>
  )
}

function LinkedRating({activity}) {
  return (
    <Link to={`/activity/${activity.slug}`}>
      <div className="rating">
        <Rating activity={activity} />
      </div>
    </Link>
  )
}

function LinkedRegions({activity}) {
  // TODO optimization: we should add the titles after loading the catalogue ... or on the server
  const [titles, setTitles] = useState([]);
  useEffect(() => {
    if(activity) {
      const regionTitles = activity.regions
      .map(regionCode => {
        const regionTitle = Data.Regions.getTitle(regionCode, "de").replace("Region", "").trim();
        return regionTitle
      })
      .sort((a, b) => a > b ? 1:-1)
      .join(', ')
      setTitles(regionTitles);
    }
  }, [activity]);
  
  return (
    <Link to={`/activity/${activity.slug}`}>
      <div className="regions">
        verfügbar in: {titles}
      </div>
    </Link>
  )
}

export default ActivityLink